import { render, staticRenderFns } from "./PayRefill.vue?vue&type=template&id=3b2b85d1&"
import script from "./PayRefill.vue?vue&type=script&lang=js&"
export * from "./PayRefill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports